import * as ProxyHelper from './microfrontend-helper';

const ProxyManager = {
  ProxyHelper,
};

export default ProxyManager;
